/**
 * Session Warning Component
 * Displays warnings when user session is about to expire
 */

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { refreshSession, getSessionInfo } from '../utils/sessionManager';
import './SessionWarning.css';

const SessionWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    // Set up global function for showing session warning
    window.showSessionWarning = (days) => {
      setDaysRemaining(days);
      setShowWarning(true);
    };

    // Check session status on mount
    checkSessionStatus();

    // Check session status every minute
    const interval = setInterval(checkSessionStatus, 60000);

    return () => {
      clearInterval(interval);
      window.showSessionWarning = null;
    };
  }, []);

  const checkSessionStatus = () => {
    const sessionInfo = getSessionInfo();
    if (sessionInfo && sessionInfo.daysUntilExpiry <= 7 && sessionInfo.daysUntilExpiry > 0) {
      setDaysRemaining(sessionInfo.daysUntilExpiry);
      setShowWarning(true);
    }
  };

  const handleRefreshSession = () => {
    refreshSession();
    setShowWarning(false);
  };

  const handleDismiss = () => {
    setShowWarning(false);
  };

  if (!showWarning) {
    return null;
  }

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className="session-warning-header">
          <h3>⚠️ Session Warning</h3>
        </div>
        
        <div className="session-warning-content">
          <p>
            Your session will expire in <strong>{daysRemaining} days</strong> due to inactivity.
          </p>
          <p>
            To keep your session active, simply use the app or click "Refresh Session" below.
          </p>
        </div>
        
        <div className="session-warning-actions">
          <button 
            className="session-warning-refresh"
            onClick={handleRefreshSession}
          >
            🔄 Refresh Session
          </button>
          <button 
            className="session-warning-dismiss"
            onClick={handleDismiss}
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarning;
